import React from 'react'
import { injectIntl } from 'react-intl'

const Address = ({intl}) => (
  <div>
    <h3>Bronda</h3>

    <address>
      <a href="https://www.google.fi/maps/place/Eteläesplanadi+20,+00101+Helsinki/" rel="noopener noreferrer">Eteläesplanadi 20</a><br />
      00101 Helsinki
    </address>

    <a href="mailto:info@ravintolabronda.fi">info@ravintolabronda.fi</a>
    <a href="tel:+358103229388">{intl.locale==='en'?'+358 ':'0'}10 322 9388</a>

    <a href="https://www.facebook.com/restaurantbronda/" className="some facebook">Facebook</a>
    <a href="https://www.instagram.com/ravintolabronda/" className="some instagram">Instagram</a>
    <a href="https://www.linkedin.com/company/bw-restaurants-oy/" className="some linkedin">LinkedIn</a>
  </div>
)

export default injectIntl(Address);


// WEBPACK FOOTER //
// ./src/components/Address.js